define([
    "./externalFreightModule",
    "./externalFreightService",
    "./externalFreightServiceUrl",
    "./externalFreightOptionsModal/externalFreightOptionsModal"
], function () {
});